import { createContext, useContext } from 'react';

const PartnerManagerContext = createContext({});

PartnerManagerContext.displayName = 'PartnerManagerContext';

const usePartnerManager = () => useContext(PartnerManagerContext);

export { PartnerManagerContext, usePartnerManager };
